export default __webpack_public_path__ + "static/media/pierre-jean.adf4a439.png";